"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerFeedback = exports.CustomerSupportAction = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const uuid_1 = require("uuid");
const transformToDate_1 = require("../transformers/transformToDate");
const CustomerFeedbackStop_1 = require("./CustomerFeedbackStop");
class CustomerSupportAction {
    requestScheduledFor;
    ticketId;
}
exports.CustomerSupportAction = CustomerSupportAction;
let CustomerFeedback = class CustomerFeedback {
    _id = (0, uuid_1.v4)();
    createdAt = new Date(); // requested at
    orderId;
    driverUserId;
    textScore; // management will fill this after reading the customers response (text)
    // 5 = good, 4 = neutral, 3 = bad, 2 = fire, 1 = FIRE
    text; // defined when the customer respond
    stops;
    customerSupportAction;
};
exports.CustomerFeedback = CustomerFeedback;
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.ObjectIdColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CustomerFeedback.prototype, "_id", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], CustomerFeedback.prototype, "createdAt", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, typeorm_1.Index)(),
    __metadata("design:type", String)
], CustomerFeedback.prototype, "orderId", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CustomerFeedback.prototype, "driverUserId", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => type_graphql_1.Int, { nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], CustomerFeedback.prototype, "textScore", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CustomerFeedback.prototype, "text", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => [CustomerFeedbackStop_1.CustomerFeedbackStop], { nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => CustomerFeedbackStop_1.CustomerFeedbackStop),
    __metadata("design:type", Array)
], CustomerFeedback.prototype, "stops", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => CustomerSupportAction),
    __metadata("design:type", CustomerSupportAction)
], CustomerFeedback.prototype, "customerSupportAction", void 0);
exports.CustomerFeedback = CustomerFeedback = __decorate([
    (0, type_graphql_1.ObjectType)("CustomerFeedback"),
    (0, type_graphql_1.InputType)("CustomerFeedbackInput"),
    (0, typeorm_1.Entity)("customerFeedbacks")
], CustomerFeedback);
//# sourceMappingURL=CustomerFeedback.js.map